import script from "./SearchBarComp.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBarComp.vue?vue&type=script&setup=true&lang=js"

import "./SearchBarComp.vue?vue&type=style&index=0&id=35f9e04e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f9e04e"]])

export default __exports__